import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

const calloutVariants = {
  info: {
    barColor: 'blue.main',
  },
  success: {
    barColor: 'green.main',
  },
  warning: {
    barColor: 'orange.main',
  },
  error: {
    barColor: 'red.main',
  },
  default: {
    barColor: 'grey.main',
  },
};

export const Callout = superstyled({
  name: 'Callout',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.main,
    borderRadius: theme.shape.rounded.lg,
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  }),
});

export const Bar = superstyled({
  name: 'Callout',
  slot: 'Bar',
  tag: Box,
  propsNeeded: ['variant'],
  styles: ({ theme, variant }) => {
    const colors = calloutVariants[variant] || calloutVariants.default;
    return {
      width: theme.spacing(0.5),
      backgroundColor: theme.palette.background[colors.barColor.split('.')[0]]?.[colors.barColor.split('.')[1]],
      flexShrink: 0,
      borderRadius: theme.shape.rounded.full,
    };
  },
});

export const Content = superstyled({
  name: 'Callout',
  slot: 'Content',
  tag: Stack,
  styles: () => ({
    flex: 1,
  }),
});
